import React from 'react'

import { type ButtonProps } from './Button.models'
import { ButtonWrapper } from './ButtonComponents/ButtonWrapper'
import IconButton from './ButtonComponents/IconButton'
import { hasValue } from '../../module'
import { c } from '../../translations/LibraryTranslationService'

const Button = (props: ButtonProps): React.JSX.Element => {
  const { children, icon, destructive } = props

  if (hasValue(children) && icon) {
    throw new Error(c('errorButtonCannotAddBoth'))
  }
  if (!hasValue(children) && !icon) {
    throw new Error(c('errorButtonChooseOne'))
  }

  return icon ? (
    <IconButton buttonProps={props} icon={icon} destructive={destructive} />
  ) : (
    <ButtonWrapper {...props} />
  )
}

export default Button
